import React from 'react';
import { Card, CardBody, Row, Col, Table } from 'reactstrap';
import { Bar, Pie } from 'react-chartjs-2';

const MembershipAnalysis = ({ data }) => {
  // Gráfico de membresías más populares
  const membershipData = {
    labels: data?.membershipStats?.map(item => item.name) || [],
    datasets: [
      {
        label: 'Clientes',
        data: data?.membershipStats?.map(item => item.count) || [],
        backgroundColor: [
          'rgba(44, 168, 255, 0.8)',
          'rgba(40, 167, 69, 0.8)',
          'rgba(255, 193, 7, 0.8)',
          'rgba(220, 53, 69, 0.8)',
          'rgba(108, 117, 125, 0.8)'
        ],
        borderColor: [
          '#2CA8FF',
          '#28a745',
          '#ffc107',
          '#dc3545',
          '#6c757d'
        ],
        borderWidth: 1
      }
    ]
  };

  // Gráfico de renovaciones por mes
  const renewalData = {
    labels: data?.renewalStats?.map(item => item.month) || [],
    datasets: [
      {
        label: 'Renovaciones',
        data: data?.renewalStats?.map(item => item.count) || [],
        backgroundColor: 'rgba(127, 101, 82, 0.8)',
        borderColor: '#7F6552',
        borderWidth: 1
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      }
    },
    scales: {
      y: {
        beginAtZero: true
      }
    }
  };

  const pieOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      }
    }
  };

  return (
    <Row className="mb-4">
      {/* Gráfico de membresías populares */}
      <Col lg="6" md="12" className="mb-4">
        <Card style={{ height: '400px' }}>
          <CardBody>
            <h5 className="card-title mb-3">Membresías Más Populares</h5>
            <div style={{ height: '300px' }}>
              <Bar data={membershipData} options={chartOptions} />
            </div>
          </CardBody>
        </Card>
      </Col>

      {/* Gráfico de renovaciones */}
      <Col lg="6" md="12" className="mb-4">
        <Card style={{ height: '400px' }}>
          <CardBody>
            <h5 className="card-title mb-3">Renovaciones por Mes</h5>
            <div style={{ height: '300px' }}>
              <Bar data={renewalData} options={chartOptions} />
            </div>
          </CardBody>
        </Card>
      </Col>

      {/* Tabla de membresías detallada */}
      <Col lg="12" className="mb-4">
        <Card>
          <CardBody>
            <h5 className="card-title mb-3">Análisis Detallado de Membresías</h5>
            <Table responsive striped>
              <thead>
                <tr>
                  <th>Membresía</th>
                  <th>Clientes Activos</th>
                  <th>Clases por Mes</th>
                  <th>Precio</th>
                  <th>% del Total</th>
                  <th>Ingresos Mensuales</th>
                </tr>
              </thead>
              <tbody>
                {data?.membershipDetails?.map((membership, index) => (
                  <tr key={index}>
                    <td>
                      <strong>{membership.name}</strong>
                    </td>
                    <td>
                      <span className="badge badge-primary">
                        {membership.active_clients}
                      </span>
                    </td>
                    <td>{membership.classes_per_month}</td>
                    <td>Q {(membership.price || 0).toFixed(2)}</td>
                    <td>
                      <div className="progress" style={{ height: '20px' }}>
                        <div 
                          className="progress-bar" 
                          style={{ 
                            width: `${Number(membership.percentage || 0)}%`,
                            backgroundColor: '#7F6552'
                          }}
                        >
                          {(membership.percentage || 0).toFixed(1)}%
                        </div>
                      </div>
                    </td>
                    <td>
                      <strong>Q {(membership.monthly_revenue || 0).toFixed(2)}</strong>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default MembershipAnalysis;
